import type { JsonValue } from '../serializable';
import { toIsoString } from '../chat/iso-date';
import { toJsonObject } from './build-webhook-run-input';

/** Representative timestamp for cron run-input samples in the workflow editor. */
export const CRON_RUN_INPUT_SAMPLE_TIMESTAMP = '2026-01-01T00:00:00.000Z';

/** Merges cron trigger defaults with the fire time injected as `timestamp`. */
export function buildCronRunInput(
  defaultInput: unknown,
  triggeredAt: Date | number | string
): { [key: string]: JsonValue } {
  const base = toJsonObject(defaultInput);
  return {
    ...base,
    timestamp: toIsoString(
      typeof triggeredAt === 'number' ? new Date(triggeredAt) : triggeredAt
    ),
  };
}
